/**
 * An array of objects representing checkbox options for packet type.
 */
export const checkboxType = [
    { value: 'viewall', label: 'View All' },
    { value: 'digital', label: 'Digital' },
    { value: 'hybrid', label: 'Hybrid' },
    { value: 'incomplete', label: 'Incomplete' },
];
